import _ from 'lodash';

export const sortTree = tree => {
  if (tree.children) {
    const folders = tree.children.filter(item => item.isExtension);
    const extensions = tree.children.filter(item => !item.isExtension);
    tree.children = [
      ..._.sortBy(folders, ['name']),
      ..._.sortBy(extensions, ['name']),
    ];
  }

  tree.children.forEach(item => {
    if (item && item.children && item.children.length) {
      sortTree(item);
    }
  });
};

export const getTreeWithChangedFolderName = (tree, id, name) => {
  if (tree && tree.children) {
    const folder = tree.children.find(item => item.id === id);
    if (folder) {
      folder.name = name;
      return tree;
    }
  }

  tree.children.forEach(item => {
    if (item && item.children && item.children.length) {
      getTreeWithChangedFolderName(item, id, name);
    }
  });

  return tree;
};

export const mapTree = (treeLevel, isRoot = true) => {
  if (treeLevel) {
    if (isRoot) {
      return treeLevel.children
        ? treeLevel.children.map(child => mapTree(child, false))
        : [];
    }
    return {
      title: treeLevel.name,
      id: treeLevel.id,
      url: treeLevel.url,
      children: treeLevel.children
        ? treeLevel.children.map(child => mapTree(child, false))
        : [],
      expanded: true,
      isExtension: treeLevel.isExtension,
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/media-hub/utils.js